import {
  APP_SETTING_TOGGLE_PROJECT_DEFAULT_CSS_BEGIN,
  APP_SETTING_TOGGLE_PROJECT_DEFAULT_CSS_SUCCESS,
  APP_SETTING_TOGGLE_PROJECT_DEFAULT_CSS_FAILURE,
  APP_SETTING_TOGGLE_PROJECT_DEFAULT_CSS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function toggleProjectDefaultCss(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_TOGGLE_PROJECT_DEFAULT_CSS_BEGIN,
    });
    const { projectId, version, data } = args;
    const header = builderSurfaceJsonContentHeader(projectId);

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/toggle-unload-default-css`,
        data,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_TOGGLE_PROJECT_DEFAULT_CSS_SUCCESS,
            data: res.data,
          });
          toast.success('Updated Successfully !', {});
          resolve(res.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: APP_SETTING_TOGGLE_PROJECT_DEFAULT_CSS_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissToggleProjectDefaultCssError() {
  return {
    type: APP_SETTING_TOGGLE_PROJECT_DEFAULT_CSS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_TOGGLE_PROJECT_DEFAULT_CSS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        toggleProjectDefaultCssPending: true,
        toggleProjectDefaultCssError: null,
      };

    case APP_SETTING_TOGGLE_PROJECT_DEFAULT_CSS_SUCCESS:
      // The request is success
      return {
        ...state,
        toggleProjectDefaultCssPending: false,
        toggleProjectDefaultCssError: null,
        projectDetail: action.data,
      };

    case APP_SETTING_TOGGLE_PROJECT_DEFAULT_CSS_FAILURE:
      // The request is failed
      return {
        ...state,
        toggleProjectDefaultCssPending: false,
        toggleProjectDefaultCssError: action.data.error,
      };

    case APP_SETTING_TOGGLE_PROJECT_DEFAULT_CSS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        toggleProjectDefaultCssError: null,
      };

    default:
      return state;
  }
}
